import { validateEmail } from './validators';

export const TimeOfDay = {
    Morning: 'morning',
    Afternoon: 'afternoon',
    Evening: 'evening',
} as const;

export type TimeOfDay = typeof TimeOfDay[keyof typeof TimeOfDay];

export function getTimeOfDay(date: Date = new Date()): TimeOfDay {
    const hour = date.getHours();
    if (hour >= 5 && hour < 12) return TimeOfDay.Morning;
    if (hour >= 12 && hour < 18) return TimeOfDay.Afternoon;
    return TimeOfDay.Evening;
}

export function getFirstName(displayName: string | null | undefined): string {
    const trimmed = displayName?.trim();
    if (!trimmed) return '';
    // Some accounts have their email address as username instead of a real display name — that's
    // not a first name, so treat it the same as no name at all rather than greeting by full address.
    if (validateEmail(trimmed)) return '';
    return trimmed.split(/\s+/)[0];
}
